import React from "react";

/** Multi-edit sliders of the "Multi-Set Up" button (Figma 187:60585 left icon). */
export const MultiEditIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M4.2 6.2h7.1M14.5 6.2h1.3M4.2 10h1.3M8.7 10h7.1M4.2 13.8h7.1M14.5 13.8h1.3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="13" cy="6.2" r="1.5" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="7.2" cy="10" r="1.5" stroke="currentColor" strokeWidth="1.5" />
    <circle
      cx="13"
      cy="13.8"
      r="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

/** Trash can of the "Remove" button (Figma 187:60586 left icon). */
export const TrashIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M3.3 5.5h13.4M8 3.2h4M4.8 5.5l.8 10.1a1.6 1.6 0 0 0 1.6 1.5h5.6a1.6 1.6 0 0 0 1.6-1.5l.8-10.1M8.2 8.6v5M11.8 8.6v5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
